/* Keep fixed-city images and labels in sync with the native variant selection. */
(() => {
  'use strict';
  if (window.nfStaticCityMapInitialized) return;
  const node = document.querySelector('[data-nf-static-city-config]');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  window.nfStaticCityMapInitialized = true;

  const variants = Array.isArray(config.variants) ? config.variants : [];
  const productSelector = '[data-product-id="' + config.productId + '"]';
  const sizeOf = variant => String(variant?.option1 || '').trim();
  const variantById = id => variants.find(variant => String(variant.id) === String(id));
  const selectedVariant = () => {
    const input = document.querySelector('product-form-component' + productSelector + ' input[name="id"]');
    return variantById(input?.value) || variants[0];
  };
  function syncGallery(variant) {
    if (!variant) return;
    const size = sizeOf(variant).startsWith('44') ? '44' : '22';
    const gallery = document.querySelector('[data-nf-owner-gallery]' + productSelector);
    const selected = gallery?.querySelector('[data-nf-owner-variant="' + variant.id + '"]');
    if (selected) {
      const url = selected.dataset.nfImageUrl;
      const missing = url.includes('nf-city-map-size-guide');
      const image = gallery.querySelector('[data-nf-owner-image]');
      if (image.getAttribute('src') !== url) image.setAttribute('src', url);
      image.alt = (config.title || config.handle) + ' · ' + variant.option1 + ' · ' + variant.option2
        + (missing ? ' · Størrelsesguide, produktfoto afventer' : '');
      gallery.querySelector('[data-nf-owner-full]').setAttribute('href', url);
      gallery.dataset.variantId = String(variant.id);
      gallery.querySelector('[data-nf-owner-missing]').hidden = !missing;
      const caption = variant.option1 + ' · ' + variant.option2 + ' · ' + (size === '44' ? '4 dele á 22 × 22 cm' : '1 del');
      const captionNode = gallery.querySelector('[data-nf-owner-caption]');
      if (captionNode.textContent !== caption) captionNode.textContent = caption;
      for (const link of gallery.querySelectorAll('[data-nf-owner-variant]')) {
        if (link === selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        const target = new URL(link.href);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) target.searchParams.set('preview_theme_id', preview);
        if (link.href !== target.href) link.href = target.href;
      }
      for (const img of document.querySelectorAll('sticky-add-to-cart' + productSelector + ' img')) {
        img.removeAttribute('srcset');
        if (img.getAttribute('src') !== url) img.setAttribute('src', url);
        img.alt = image.alt;
      }
    }
    const price = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', maximumFractionDigits: 0 }).format(variant.price / 100);
    const label = 'Valgt: ' + variant.option1 + ' · ' + variant.option2 + ' · '
      + (size === '44' ? '4 dele á 22 × 22 cm' : '1 del') + ' · ' + price + ' uden ramme';
    for (const labelNode of document.querySelectorAll('[data-nf-static-selection]')) {
      if (labelNode.textContent !== label) labelNode.textContent = label;
    }
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; syncGallery(selectedVariant()); });
  }
  for (const event of ['change', 'variant:update', 'product:variant-change', 'shopify:section:load']) {
    document.addEventListener(event, schedule);
  }
  new MutationObserver(schedule).observe(document.querySelector('#MainContent') || document.body, {
    childList: true,
    subtree: true
  });
  syncGallery(selectedVariant());
})();
